import { render, staticRenderFns } from "./CircleIcon.vue?vue&type=template&id=958d2828&"
import script from "./CircleIcon.vue?vue&type=script&lang=ts&"
export * from "./CircleIcon.vue?vue&type=script&lang=ts&"
import style0 from "./CircleIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports